import { useCallback, useMemo } from "react";
import { useIntl } from "react-intl";
export var useIssueDateFormatter = function () {
    var formatMessage = useIntl().formatMessage;
    var weekdays = useMemo(function () {
        return Array.from({ length: 7 }, function (_, dayIndex) {
            return formatMessage({
                id: "ui-br-legaldeposits.periodicals.matrix.weekday.full.".concat(dayIndex),
            }).toLocaleLowerCase();
        });
    }, [formatMessage]);
    return useCallback(function (iso) {
        if (!iso)
            return "";
        var _a = iso.split("-").map(Number), year = _a[0], month = _a[1], day = _a[2];
        var date = new Date(year, month - 1, day);
        return "".concat(weekdays[date.getDay()], " ").concat(day, ".").concat(month, ".");
    }, [weekdays]);
};
